import React from 'react'
import { Box, Container, Typography, Link } from '@mui/material'
import logo from '../assets/logo.svg'

const POLICY_URL = process.env.REACT_APP_POLICY_URL || 'https://media.mygroupbooker.com/policy'

const Footer = ({ company }) => {
  const registeredLine = [
    company?.registeredAddress,
    company?.registeredPostCode,
  ]
    .filter(Boolean)
    .join(', ')

  return (
    <Box
      component='footer'
      sx={{
        backgroundColor: '#201e31',
        color: 'white',
        py: 4,
        mt: 'auto',
      }}
    >
      <Container maxWidth='lg'>
        {company?.companyNumber && (
          <Typography
            variant='body2'
            sx={{
              fontSize: '0.75rem',
              opacity: 0.8,
              textAlign: 'center',
              mb: 2,
            }}
          >
            {company.name} is a company registered in England and Wales.
            Company number {company.companyNumber}
            {registeredLine && `. Registered office: ${registeredLine}`}.
          </Typography>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'center', md: 'center' },
            gap: 3,
          }}
        >
          {/* GroupBooker Branding */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box
              component='img'
              src={logo}
              alt='GroupBooker'
              sx={{
                width: 40,
                height: 40,
              }}
            />
            <Box>
              <Typography variant='body2' sx={{ fontSize: '0.75rem', opacity: 0.8 }}>
                © GroupBooker {new Date().getFullYear()}. All Rights Reserved.
              </Typography>
            </Box>
          </Box>

          {/* Footer Links */}
          <Box
            sx={{
              display: 'flex',
              gap: { xs: 2, md: 3 },
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            <Link
              href={`${POLICY_URL}/terms-and-conditions.html`}
              target='_blank'
              rel='noopener noreferrer'
              color='inherit'
              underline='hover'
              sx={{ fontSize: '0.875rem', opacity: 0.9 }}
            >
              Terms of Use
            </Link>
            <Link
              href={`${POLICY_URL}/privacy-policy.html`}
              target='_blank'
              rel='noopener noreferrer'
              color='inherit'
              underline='hover'
              sx={{ fontSize: '0.875rem', opacity: 0.9 }}
            >
              Privacy Policy
            </Link>
            <Link
              href='mailto:support.groupbooker@meta-cannect.com'
              color='inherit'
              underline='hover'
              sx={{ fontSize: '0.875rem', opacity: 0.9 }}
            >
              Support
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
